import * as yup from "yup";

import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
import InputText from "../../../../components/hookForms/textField";
import RadioButton from "../../../../components/hookForms/radioButton";
import messages from "../../../../utils/messages";
import serviceMotivoMovimentacaoInstalacao from "../../../../services/serviceMotivoMovimentacaoInstalacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
    onSuccess: () => void;
}

export default function DialogCreate({ open, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [requiredInjecao, setRequiredInjecao] = useState(false);
    const [disablePercentual, setDisablePercentual] = useState(false);
    const [disableFixa, setDisableFixa] = useState(false);
    const [tipoAlteracao, setTipoAlteracao] = useState(false);

    const validationSchema = yup.object().shape({
        observacao: yup.string().required(messages.requiredField),
        tipo: yup.string().required(messages.requiredField),
        descricao: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            observacao: "",
            tipoAlteracao: "",
            valorInjecaoPercentual: "",
            valorInjecaoFixa: "",
            tipo: "",
            descricao: "",
        },
    });

    const tipoOptions = [
        { label: "Inclusão", value: "I" },
        { label: "Alteração", value: "A" },
        { label: "Exclusão", value: "E" },
    ];

    const handleChangeTipoAlteracao = (event: any) => {
        if (event?.target?.value === "Cota") {
            setRequiredInjecao(true);
        } else {
            setRequiredInjecao(false);
        }
    };

    const Validate = (values: any) => {
        if (values.tipo && values.tipo === "A") {
            if (!values.tipoAlteracao) {
                toast.error("Tipo alteração deve ser informado para Tipo igual a 'Alteração'");
                return false;
            }
            if (values.tipoAlteracao === "I" && !values.valorInjecaoFixa && !values.valorInjecaoPercentual) {
                toast.error(
                    "Valor injeção fixa OU Valor injeção percentual devem ser informados para tipo alteração igual a Injeção"
                );
                return false;
            }
        }
        return true;
    };

    function onBlur(e: any) {
        if (e.target.value && e.target.name === "valorInjecaoFixa") {
            setDisablePercentual(true);
        } else {
            setDisablePercentual(false);
        }

        if (e.target.value && e.target.name === "valorInjecaoPercentual") {
            setDisableFixa(true);
        } else {
            setDisableFixa(false);
        }
    }

    function handleChange(e: any) {
        if (e && e === "A") {
            setTipoAlteracao(true);
        } else {
            setTipoAlteracao(false);
        }
    }

    function resetType() {
        setTipoAlteracao(false);
    }

    function onSubmit(values: any) {
        const treatedValues = {
            ...values,
            ativo: "S",
            valorInjecaoFixa:
                values.tipo !== "A"
                    ? 0
                    : values.tipoAlteracao !== "Cota" && values.valorInjecaoFixa
                    ? Number(values.valorInjecaoFixa.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
            valorInjecaoPercentual:
                values.tipo !== "A"
                    ? 0
                    : values.tipoAlteracao !== "Cota" && values.valorInjecaoPercentual
                    ? Number(values.valorInjecaoPercentual.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
            tipoAlteracao:
                values.tipo !== "A"
                    ? ""
                    : values.tipoAlteracao === "Injeção"
                    ? "I"
                    : values.tipoAlteracao === "Cota"
                    ? "C"
                    : "",
        };

        if (Validate(treatedValues)) {
            setDisable(true);

            serviceMotivoMovimentacaoInstalacao
                .create(treatedValues)
                .then((result) => {
                    if (result) {
                        toast.success(messages.reportSucess);
                        onSuccess();
                        onClose();
                        reset();
                        resetType();
                    }
                })
                .catch(() => {
                    toast.error(messages.reportError);
                })
                .finally(() => {
                    setDisable(false);
                });
        }
    }

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={() => {
                    onClose();
                    reset();
                    resetType();
                }}
                open={open}
            >
                <DialogTitle>
                    Novo motivo de movimentação instalação
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                            resetType();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            // color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid container spacing={2} display="flex" alignItems="center">
                            <Grid item xs={12} md={8}>
                                <InputText name="descricao" label="Motivo" control={control} error={errors} />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <AutoComplete
                                    name="tipo"
                                    label="Tipo"
                                    onChange={(e: any) => handleChange(e)}
                                    options={tipoOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            {tipoAlteracao && (
                                <>
                                    <Grid item xs={12} md={4}>
                                        <RadioButton
                                            title="Tipo alteração"
                                            name="tipoAlteracao"
                                            onChange={(event: any) => handleChangeTipoAlteracao(event)}
                                            opt1="Cota"
                                            opt2="Injeção"
                                            control={control}
                                            error={errors}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <InputNumber
                                            name="valorInjecaoFixa"
                                            label="Injeção fixa"
                                            control={control}
                                            error={errors}
                                            onBlur={onBlur}
                                            decimalScale={2}
                                            noThousandSeparator
                                            maxLength={6}
                                            disabled={requiredInjecao || disableFixa}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <InputNumber
                                            name="valorInjecaoPercentual"
                                            label="Injeção %"
                                            control={control}
                                            error={errors}
                                            onBlur={onBlur}
                                            decimalScale={2}
                                            noThousandSeparator
                                            maxLength={6}
                                            disabled={requiredInjecao || disablePercentual}
                                        />
                                    </Grid>
                                </>
                            )}

                            <Grid item xs={12} md={12}>
                                <InputText name="observacao" label="Observação" control={control} error={errors} />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "120px" }}
                            onClick={() => {
                                reset();
                                onClose();
                                resetType();
                            }}
                            color="warning"
                            variant="outlined"
                        >
                            Cancelar
                        </Button>
                        <Button style={{ width: "120px" }} type="submit" variant="contained" disabled={isDisable}>
                            Salvar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
